<template>
    <v-card>
        <v-card-title>Настройка блока</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="2">
                        <v-text-field type="number" v-model="block.fontSize" label="A+-"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-color-picker class="ma-2 color-picker" v-model="block.color" show-swatches swatches-max-height="100px"></v-color-picker>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-slider
                                v-model="block.paddingTop"
                                min="0"
                                max="150"
                                thumb-label="always"
                                label="отступ сверху"
                        ></v-slider>
                        <v-slider
                                v-model="block.paddingBottom"
                                min="0"
                                max="150"
                                thumb-label="always"
                                label="отступ снизу"
                        ></v-slider> <v-slider
                            v-model="block.paddingRight"
                            min="0"
                            max="500"
                            thumb-label="always"
                            label="отступ справа"
                    ></v-slider> <v-slider
                            v-model="block.paddingLeft"
                            min="0"
                            max="500"
                            thumb-label="always"
                            label="отступ слева"
                    ></v-slider>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <div class="flex-md-grow-1"></div>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="$emit('close-settings')"
            >
                Закрыть
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "TextBlockSettings",
        props: ['value'],
        data: () => ({
            block: {

            }
        }),
        watch:{
            block: {
                handler(){
                    this.$emit('change', this.block)
                },
                deep: true
            }
        },
        methods:{
            save(){

            }
        },
        mounted(){
            this.block = this.value
        }
    }
</script>

<style scoped>

</style>
